export const getLanguagesRestApi = (HTTPProfileManager) => HTTPProfileManager.get('public/languages').then((res) => res.data);
//# sourceMappingURL=language.api.js.map